module.exports = __webpack_public_path__ + "static/media/logo_lacost_800X334.3c50a0ce.png";